import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  Wifi,
  Wrench,
  Network,
  Camera,
  Home,
  ShieldCheck,
  Laptop,
  GraduationCap,
} from 'lucide-react';

const servicesData = [
  {
    id: 1,
    icon: Network,
    title: 'Managed Networks',
    description: 'Professional management of home and business networks with proactive monitoring and optimization.',
  },
  {
    id: 2,
    icon: Wifi,
    title: 'Router & Wi-Fi Setup',
    description: 'Expert configuration of routers and Wi-Fi access points for optimal coverage and performance.',
  },
  {
    id: 3,
    icon: Laptop,
    title: 'Computer Repair',
    description: 'Fast and reliable computer repair and troubleshooting services to keep you running smoothly.',
  },
  {
    id: 4,
    icon: Wrench,
    title: 'Network Installation',
    description: 'New network installation and upgrades tailored to your specific requirements and budget.',
  },
  {
    id: 5,
    icon: Camera,
    title: 'Security Cameras',
    description: 'Professional installation and monitoring of security camera systems for complete peace of mind.',
  },
  {
    id: 6,
    icon: Home,
    title: 'Smart Home Setup',
    description: 'Seamless smart home setup and integration for enhanced convenience and automation.',
  },
  {
    id: 7,
    icon: ShieldCheck,
    title: 'Security & Data Protection',
    description: 'Comprehensive security and data protection solutions to safeguard your digital assets.',
  },
  {
    id: 8,
    icon: GraduationCap,
    title: 'Customer Training',
    description: 'At-home, one-on-one customer education to help you confidently use and manage your technology.',
  },
];

const Services = () => {
  return (
    <section id="services" className="relative py-24 lg:py-32 bg-slate-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">Services</span>
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Comprehensive IT solutions designed to keep your technology reliable, secure, and efficient.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={service.id}
                className="group bg-slate-900/50 border-slate-800 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10 backdrop-blur-sm hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-8 space-y-4">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-cyan-500/10 rounded-xl flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors duration-300 group-hover:scale-110">
                    <IconComponent className="w-7 h-7 text-cyan-400" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-white group-hover:text-cyan-400 transition-colors duration-300">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-slate-400 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;